import { JSX } from "preact/jsx-runtime";

export interface IconProps {
  name: string;
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

export function Icon({
  name,
  width,
  height,
  className = "",
  color,
}: IconProps): JSX.Element {
  if (name === "triangle") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={30}
        height={16}
        viewBox="0 0 30 16"
        fill="none"
        className={className}
        style={color ? { color } : undefined}
      >
        <path d="M15 13L27.9904 5.5H2.00962L15 13Z" fill="#F66830" />
      </svg>
    );
  }
  if (name === "close") {
    return (
      <svg
        width={width}
        height={height}
        className={className}
        style={color ? { color } : undefined}
        viewBox="0 0 20 20"
      >
        <rect width="20" height="20" rx="10" fill="#111111" />
        <path
          d="M9.92737 8.13056L13.8503 4.20764L15.6484 6.00579L11.7255 9.92871L15.6484 13.8516L13.8503 15.6498L9.92737 11.7269L6.00583 15.6484L4.20768 13.8503L8.12922 9.92871L4.20768 6.00717L6.00583 4.20902L9.92737 8.13056Z"
          fill="#707071"
        />
      </svg>
    );
  }
  if (name === "language") {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.4668 7.66602H16.5335"
          stroke="#707071"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.4668 12.334H16.5335"
          stroke="#707071"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.6114 3C8.30111 5.0997 7.60645 7.52501 7.60645 10C7.60645 12.475 8.30111 14.9003 9.6114 17"
          stroke="#707071"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.3887 3C11.699 5.0997 12.3936 7.52501 12.3936 10C12.3936 12.475 11.699 14.9003 10.3887 17"
          stroke="#707071"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
          stroke="#707071"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      className={className}
      style={color ? { color } : undefined}
    >
      <use href={`/sprite.svg?v=1253#icon-${name}`} />
    </svg>
  );
}
